import { render, staticRenderFns } from "./ParametrosGerais.vue?vue&type=template&id=717d6432&scoped=true"
import script from "./ParametrosGerais.vue?vue&type=script&lang=js"
export * from "./ParametrosGerais.vue?vue&type=script&lang=js"
import style0 from "./ParametrosGerais.vue?vue&type=style&index=0&id=717d6432&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717d6432",
  null
  
)

export default component.exports